import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
// import { useLogoutUserQuery } from '../../store/api/authApi';
import { useAppDispatch } from '../../store/hooks';
import { reset } from '../../store/state/authSlice';

type Props = {};

const AuthLogout = (props: Props) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  // const { isSuccess } = useLogoutUserQuery('');

  useEffect(() => {
    // if (isSuccess) {
      localStorage.removeItem('login');
      localStorage.removeItem('labourDetail');
      sessionStorage.clear();
      dispatch(reset());
      navigate('/login');
      toast.success('You have logged out');
    // }
  }, []);

  return <div></div>;
};

export default AuthLogout;
